<template>
  <div :class="'Elinput_'+id">
        <el-input :readonly="isReadonly" :disabled="disabled" :placeholder="InputTextParm.placeholder" v-model="inputData"   @input="addStr" @compositionstart.native="isComposing = true" @compositionend.native="onCompositionEnd" @keydown.enter.native="addStr()"  @blur="CheMandatory()"  >
          <i v-if="checkStrusShow && !loadingStrus" style="position: relative;top: 8px;"
          slot="suffix">
          <img src="../../assets/images/inputCheck.svg" class="icon_input">
        </i>
        <i v-if="loadingStrus" style="position: relative;top: 8px;"
        slot="suffix">
          <img src="../../assets/images/inputLoading.svg" class="rotating-icon">
        </i>
        </el-input>
        <div v-if="HasError" v-html="ErrorText" class="ErrorTextColor errorWidth" >
        </div>
  </div>
</template>

<script>
export default {
  props:{
    InputTextParm:{
        type:Object,
        default:function () {
          return {
            placeholder:this.$t("lbl_EMPBE_Companted_Tags_Placeother_Content"),
            errorText:this.$t("lbl_EMPBE_Companted_Tags_Requeid")
          }
        }
      },
    isMandatory:{
        type:Boolean,
        default:true
    },
    checkNull:{
        type:Boolean,
        default:false
    },
    id:{
        type:String,
        default:''
    },
      isReadonly:{
        type:Boolean,
        default:false
    },
    InputStr:{
      type:String,
      default:''
    },
    disabled: {
      type:Boolean,
      default:false
    },
    CheckErrorText:
    {
      type:String,
      default:''
    },
    loadingStrus:{
      type:Boolean,
      default:false
    }
  },
  data(){
      return {
          inputData:'',
          HasError:false,
          ErrorText:'',
          isComposing: false,
      }
    },
  watch:{
    InputStr(val) {
      const next = val || '';
      if (next !== this.inputData) {
        this.inputData = next;
      }
    },
    checkNull(){
        if(this.checkNull){
          this.CheMandatory();
        }
    },
    CheckErrorText(){
      this.checkDataMethods();
    },
    HasError(){
      if(this.HasError)
      {
        document.querySelector('.Elinput_'+this.id+ '  .el-input__inner').style.setProperty('border-color', '#f56c6c');  
      }
      else
      {
        document.querySelector('.Elinput_'+this.id+ '   .el-input__inner').style.setProperty('border-color', '#DCDFE6');   
      }
    }
  },
  computed:{
    checkStrusShow(){
        return this.inputData.length>0 && this.CheckErrorText.length<1
    },
    checkStrusLoadShow(){
        return this.inputData.length>0 && this.CheckErrorText.length<1
    }
  },
  mounted(){  
    this.CreatedData();
  },
  methods:{
      CheMandatory(){
          if(!this.isReadonly && this.isMandatory && !this.disabled)
          {
              if(this.inputData.length<1)
              {
                this.HasError=true;
                this.ErrorText=this.InputTextParm.errorText;
                this.$emit("noticeMethods")
              }
          }
      },
      CreatedData(){
        if(this.InputStr.length>0){
          this.inputData =this.InputStr;
        }
      },
      onCompositionEnd() {
        this.isComposing = false;
        this.addStr();
      },
      addStr(){
        if (this.isComposing) return;
        this.HasError=false;
          if(!this.inputData){
            this.CheMandatory();
          };
            this.CreateStr();
      },
      checkDataMethods(){
        this.HasError=false;
          if(this.CheckErrorText!='')
          {
                  this.HasError=true;
                  this.ErrorText=this.CheckErrorText;
          }
          this.$emit("noticeErrorMethods",this.HasError)
      },
      CreateStr(){
        this.$emit('ChangeModelStr',this.inputData);
      },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-input__inner{
    border: 1px solid rgba(0, 0, 0, 0.25);
    border-color: rgba(0, 0, 0, 0.25);
    border-radius: 4px;
}
.ErrorTextColor{
  color: #f56c6c;
}
.errorWidth{
  
  max-width: 400px;
  font-size: 12px;
}
.rotating-icon{
  display: inline-block;
  animation: rotate 2s linear infinite; /* 2秒旋转一圈，线性速度，无限次循环 */ 
}
</style>